function initPscModal(bodyClass) {
  if (!document.body.classList.contains(bodyClass)) return;
  try {
    sessionStorage.removeItem(SESSION_ONCE_KEY);
  } catch (_) {}
  // =========================
  // KONFIG
  // =========================
  const XLSX_URL =
    "/user/documents/upload/nemazat_zdroj_dat_dopravy/psc_regions.xlsx";
  const COLUMN_PSC = "PSC";
  const COLUMN_REGION = "RegionId"; // v Excelu: 1..13
  const REGION_SELECT = "#deliveryRegionId";
  const FORM_ID = "select-country-payment";
  const SHEETJS_URL =
    "https://cdn.jsdelivr.net/npm/xlsx@0.18.5/dist/xlsx.full.min.js";

  const STORAGE_KEY = "deliveryRegionNumber"; // localStorage: "1".."13"
  const SESSION_ONCE_KEY = "pscRegionSubmittedThisLoad"; // proti smyčce v rámci 1 loadu
  const CHANGE_BTN_ID = "pscChangeZipBtn";
  document.querySelector(REGION_SELECT)?.setAttribute("disabled", "disabled");
  // =========================
  // STORAGE HELPERS
  // =========================
  const setStoredRegionNumber = (n) => {
    try {
      localStorage.setItem(STORAGE_KEY, String(n));
    } catch (_) {}
  };
  const getStoredRegionNumber = () => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      return v ? String(v).replace(/\D+/g, "") : null;
    } catch (_) {
      return null;
    }
  };
  const clearStoredRegionNumber = () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  };

  // =========================
  // SELECT/FORM HELPERS
  // =========================
  function parseRegionNumberFromText(text) {
    const m = String(text || "")
      .trim()
      .match(/^(\d{1,2})\s*Region\b/i);
    return m ? m[1] : null;
  }

  function isSelectAlreadyOnRegion(regionNumber) {
    const sel = document.querySelector(REGION_SELECT);
    if (!sel || !sel.selectedOptions || !sel.selectedOptions[0]) return false;
    const cur = parseRegionNumberFromText(sel.selectedOptions[0].textContent);
    return String(cur) === String(regionNumber);
  }

  function submitSelectCountryPaymentOnce() {
    try {
      if (sessionStorage.getItem(SESSION_ONCE_KEY) === "1") {
        console.log("[PSC] Submit už proběhl v tomto loadu, přeskočeno.");
        return;
      }
      sessionStorage.setItem(SESSION_ONCE_KEY, "1");
    } catch (_) {}

    const ensureAndSubmit = () => {
      const form = document.getElementById(FORM_ID);
      if (!form) return false;

      // pro jistotu povolíme select při serializaci formu
      const sel = document.querySelector(REGION_SELECT);
      let reenable = false;
      if (sel && sel.disabled) {
        sel.disabled = false;
        reenable = true;
      }

      setTimeout(() => {
        console.log("[PSC] Odesílám form", FORM_ID);
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else form.submit();

        if (reenable) sel.disabled = true;
      }, 50);

      return true;
    };

    if (ensureAndSubmit()) return;

    // Když form ještě není v DOM, počkejme krátce
    let tries = 0;
    const maxTries = 20; // ~2s
    const interval = setInterval(() => {
      tries++;
      if (ensureAndSubmit() || tries >= maxTries) {
        clearInterval(interval);
        if (tries >= maxTries)
          console.warn("[PSC] Form", FORM_ID, "nenalezen, vzdávám to.");
      }
    }, 100);
  }

  // vyber option podle textu "{n} Region" — bez dispatch "change"/"input"
  function selectRegionByLabelNumber(regionNumber) {
    const sel = document.querySelector(REGION_SELECT);
    if (!sel) {
      console.warn("[PSC] Select nenalezen");
      return false;
    }

    const wanted = String(regionNumber).trim();
    const rx = new RegExp(
      "^\\s*" +
        wanted.replace(/[.*+?^${}()|[\\]\\\\]/g, "\\$&") +
        "\\s*Region\\b",
      "i"
    );

    let foundValue = null;
    for (const opt of sel.options) {
      const label = (opt.textContent || "").replace(/\s+/g, " ").trim();
      if (rx.test(label)) {
        foundValue = opt.value;
        break;
      }
    }
    if (foundValue == null) {
      console.warn("[PSC] Option pro", regionNumber, "nenalezen");
      return false;
    }

    const wasDisabled = sel.disabled;
    if (wasDisabled) sel.disabled = false; // dočasně povol

    sel.value = String(foundValue); // jen nastav hodnotu, žádné change/input

    if (wasDisabled) sel.disabled = true; // vrať stav
    return true;
  }

  function selectRegionWhenReadyByLabelNumber(
    regionNumber,
    { submitAfter = false } = {}
  ) {
    const trySet = () => {
      if (isSelectAlreadyOnRegion(regionNumber)) {
        if (submitAfter) submitSelectCountryPaymentOnce();
        return true;
      }
      if (!selectRegionByLabelNumber(regionNumber)) return false;
      if (submitAfter) submitSelectCountryPaymentOnce();
      return true;
    };

    if (trySet()) return;

    const obs = new MutationObserver(() => {
      if (trySet()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  // =========================
  // MODAL
  // =========================
  function injectStyles() {
    if (document.getElementById("pscModalStyles")) return;
    const style = document.createElement("style");
    style.id = "pscModalStyles";
    style.textContent = `
      .psc-modal{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.6)}
      .psc-modal__box{width:min(92vw,360px);background:#fff;border-radius:10px;padding:20px;box-shadow:0 10px 30px rgba(0,0,0,.2)}
      .psc-modal__title{margin:0 0 10px;font-size:20px;font-weight:700}
      .psc-modal__desc{margin:0 0 14px;font-size:14px;color:#555}
      .psc-modal__row{display:grid;gap:10px}
      .psc-input{padding:12px;font-size:16px;border:1px solid #ccc;border-radius:8px}
      .psc-btn{padding:12px;font-size:16px;border:0;border-radius:8px;cursor:pointer}
      .psc-btn--primary{background:#111;color:#fff}
      .psc-error{color:#c01818;font-size:13px;margin:6px 0 0;display:none}
      .psc-loading{text-align:center;padding:18px 0;font-size:14px;color:#333}
      #${CHANGE_BTN_ID}{margin-top:8px;font:inherit;padding:6px 10px;border:1px solid #bbb;border-radius:6px;background:#f6f6f6;cursor:pointer}
      #${CHANGE_BTN_ID}:hover{background:#eee}
    `;
    document.head.appendChild(style);
  }

  function buildModal() {
    if (document.getElementById("pscModal")) return null;
    const wrap = document.createElement("div");
    wrap.id = "pscModal";
    wrap.className = "psc-modal";
    wrap.setAttribute("aria-modal", "true");
    wrap.setAttribute("role", "dialog");
    wrap.innerHTML = `
      <div class="psc-modal__box" role="document">
        <h2 class="psc-modal__title">Zadejte PSČ</h2>
        <p class="psc-modal__desc">Podle PSČ automaticky vybereme váš region doručení.</p>
        <div id="pscLoading" class="psc-loading">Načítám seznam PSČ…</div>
        <div id="pscForm" class="psc-modal__row" style="display:none">
          <input id="pscInput" class="psc-input" type="text" inputmode="numeric" placeholder="Zadejte PSČ (např. 11000)" maxlength="6" autocomplete="postal-code" />
          <button id="pscSubmit" class="psc-btn psc-btn--primary" type="button">Vybrat region</button>
          <div id="pscError" class="psc-error">Zadané PSČ nebylo nalezeno.</div>
        </div>
      </div>`;
    document.body.appendChild(wrap);
    document.documentElement.dataset._prevOverflow =
      document.documentElement.style.overflow || "";
    document.documentElement.style.overflow = "hidden";
    return wrap;
  }

  function closeModal(modal) {
    const prev = document.documentElement.dataset._prevOverflow || "";
    document.documentElement.style.overflow = prev;
    delete document.documentElement.dataset._prevOverflow;
    if (modal && modal.parentNode) modal.parentNode.removeChild(modal);
  }

  // =========================
  // XLSX → MAPA PSČ
  // =========================
  function loadXlsxAsMap(url) {
    return fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error("Fetch XLSX failed: " + r.status);
        return r.arrayBuffer();
      })
      .then((buf) => {
        const wb = window.XLSX.read(buf, { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = window.XLSX.utils.sheet_to_json(ws, { defval: "" });
        const map = {};
        for (const row of rows) {
          const rawPsc = String(row[COLUMN_PSC] ?? "").replace(/\D+/g, "");
          const regionNum = String(row[COLUMN_REGION] ?? "").replace(
            /\D+/g,
            ""
          ); // 1..13
          if (!rawPsc || !regionNum) continue;
          map[rawPsc.padStart(5, "0").slice(0, 5)] = regionNum;
        }
        return map;
      });
  }

  function ensureSheetJs() {
    return new Promise((resolve, reject) => {
      if (window.XLSX) {
        resolve();
        return;
      }
      const s = document.createElement("script");
      s.src = SHEETJS_URL;
      s.onload = resolve;
      s.onerror = () => reject(new Error("Načtení parseru selhalo."));
      document.head.appendChild(s);
    });
  }

  // =========================
  // OTEVŘENÍ MODALU A FLOW: nastav region + odešli form
  // =========================
  function openPscModalAndHandle() {
    injectStyles();
    const modal = buildModal();
    if (!modal) return;

    const onKey = (e) => {
      if (e.key === "Escape") e.preventDefault();
      if (e.key === "Enter") {
        e.preventDefault();
        modal.querySelector("#pscSubmit").click();
      }
    };
    document.addEventListener("keydown", onKey, { capture: true });

    const pscInput = modal.querySelector("#pscInput");
    const pscSubmit = modal.querySelector("#pscSubmit");
    const pscError = modal.querySelector("#pscError");
    const pscLoading = modal.querySelector("#pscLoading");
    const pscForm = modal.querySelector("#pscForm");

    const normalizePsc = (s) =>
      String(s || "")
        .replace(/\D+/g, "")
        .slice(0, 5);

    pscInput.addEventListener("input", (e) => {
      const n = normalizePsc(e.target.value);
      if (n !== e.target.value) e.target.value = n;
      pscError.style.display = "none";
    });

    let pscMap = null;
    function enableForm() {
      pscLoading.style.display = "none";
      pscForm.style.display = "grid";
      pscInput.value = "";
      pscInput.focus();
    }
    function cleanup() {
      document.removeEventListener("keydown", onKey, { capture: true });
      closeModal(modal);
    }

    function submitPsc() {
      const psc = normalizePsc(pscInput.value);
      if (!psc || psc.length < 5) {
        pscError.style.display = "block";
        return;
      }
      const regionNumber = pscMap && pscMap[psc]; // "1".."13"
      if (regionNumber) {
        setStoredRegionNumber(regionNumber);
        selectRegionWhenReadyByLabelNumber(regionNumber, { submitAfter: true }); // nastav + ODEŠLI form
        cleanup();
      } else {
        pscError.style.display = "block";
      }
    }
    pscSubmit.addEventListener("click", submitPsc);

    ensureSheetJs()
      .then(() => loadXlsxAsMap(XLSX_URL))
      .then((map) => {
        pscMap = map;
        Object.keys(map).length
          ? enableForm()
          : (pscLoading.textContent = "Mapa PSČ prázdná.");
      })
      .catch(() => {
        pscLoading.textContent = "Načítání PSČ selhalo.";
      });
  }

  // =========================
  // TLAČÍTKO „Změnit PSČ doručení“
  // =========================
  function attachChangeZipButton() {
    injectStyles();
    const addBtn = () => {
      const sel = document.querySelector(REGION_SELECT);
      if (!sel) return false;
      if (document.getElementById(CHANGE_BTN_ID)) return true;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.id = CHANGE_BTN_ID;
      btn.textContent = "Změnit PSČ doručení";
      sel.insertAdjacentElement("afterend", btn);

      btn.addEventListener("click", () => {
        clearStoredRegionNumber();
        try {
          sessionStorage.removeItem(SESSION_ONCE_KEY);
        } catch (_) {}
        openPscModalAndHandle(); // po novém výběru nastaví a odešle form
      });

      return true;
    };

    if (addBtn()) return;
    const obs = new MutationObserver(() => {
      if (addBtn()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  // =========================
  // INIT
  // =========================
  document.addEventListener("DOMContentLoaded", () => {
    const stored = getStoredRegionNumber();
    if (stored) {
      if (!isSelectAlreadyOnRegion(stored)) {
        selectRegionWhenReadyByLabelNumber(stored, { submitAfter: true });
      }
    } else {
      openPscModalAndHandle(); // po potvrzení PSČ nastaví a odešle form
    }
    attachChangeZipButton();
  });
}
export { initPscModal };
